export default function indicatorSeparatorStyle() {
  return (styles) => ({
    ...styles,
    display: 'none'
  });
}
